/**
 * Core features that are supported by all native embeds.
 *
 * All native embed must either support the feature or respond in
 * the feature handshake that its not supported.
 */
export const NativeEmbedCoreFeature = {
	/** When agreed, the parent sends selected-change events to the child when the embed's selection state changes. */
	SelectedChange: 'selected-change',
	/** When agreed, the parent sends view-mode-change events to the child when the embed switches between regular and maximize (e.g. full screen). */
	ViewModeChange: 'view-mode-change',
} as const;

/** All core feature values as an array, for use in supportedFeatures sets. */
export const allNativeEmbedCoreFeatures = Object.values(
	NativeEmbedCoreFeature,
) as (typeof NativeEmbedCoreFeature)[keyof typeof NativeEmbedCoreFeature][];

/**
 * Non-core features that are supported by some native embeds.
 */
export type NativeEmbedNonCoreFeature = string;

export type NativeEmbedFeature =
	| (typeof NativeEmbedCoreFeature)[keyof typeof NativeEmbedCoreFeature]
	| NativeEmbedNonCoreFeature;
